import React, { useEffect, useState } from "react";
import { Box, InputAdornment, TextField, Typography } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import { Button } from "rsuite";

import {
  Stack,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { TextFieldComponent } from "../../../../../components";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { merchantApi } from "../../../../../redux/api/apiConfig";
import {
  CUSTOMER_FEE_GROUP,
  FEE,
  MARKUP_FEE,
  MONTHLY_FEE,
  TRANSACTION_TYPE_FEE,
} from "../../../../../ApiUrl";
import SearchableSelectField from "../../../../../components/searchableSelectField";
import {
  formatDate,
  handleApiErrors,
  searchableSelectFetchOptions,
} from "../../../../../utils/common";
import { DatePicker } from "@mui/x-date-pickers";

const validationSchema = yup.object({
  fee: yup.number().min(0, "Fee Fixed cannot be negative"),
  currency: yup.mixed().required("Group is required."),
});

const AddEditMarkupFeeModal = ({
  onClose,
  isOpen,
  onSubmit,
  slabToEdit,
  isEdit,
  type,
}) => {
  const [loading, setLoading] = useState(false);

  const addClickHandler = async (values) => {
    const data = {
      currency: values?.currency?.value,
      fee: values?.fee,
    };
    // console.log(data);
    try {
      setLoading(true);
      const response = await merchantApi.post(MARKUP_FEE, data);
      // console.log(response);
      onSubmit();
      toast.success("Fee Added Successfully!");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // Handle errors
      const errorMessages = handleApiErrors(error);
      // Display each error in a separate snackbar
      errorMessages.forEach(({ field, message }) => {
        const formattedMessage = field ? `${field}: ${message}` : message; // Include field name if available
        toast.error(formattedMessage);
      });
    }
  };

  const editClickHandler = async (values) => {
    const data = {
      currency: values?.currency?.value,
      fee: values?.fee,
    };
    try {
      setLoading(true);
      const response = await merchantApi.patch(
        `${MARKUP_FEE}${slabToEdit?.id}/`,
        data
      );
      console.log(response);
      toast.success("Fee Updated Successfully!");
      onSubmit();

      setLoading(false);
    } catch (error) {
      setLoading(false);
      // Handle errors
      const errorMessages = handleApiErrors(error);
      // Display each error in a separate snackbar
      errorMessages.forEach(({ field, message }) => {
        const formattedMessage = field ? `${field}: ${message}` : message; // Include field name if available
        toast.error(formattedMessage);
      });
    }
  };

  const formik = useFormik({
    initialValues: {
      currency: null,
      fee: "",
    },
    validateOnBlur: true,
    validationSchema: validationSchema,
    validateOnMount: true,
    enableReinitialize: true,
    onSubmit: (values) => {
      return isEdit ? editClickHandler(values) : addClickHandler(values);
    },
  });

  useEffect(() => {
    if (slabToEdit) {
      formik.setFieldValue("fee", slabToEdit?.fee || "");
      formik.setFieldValue("currency", {
        label: `${slabToEdit?.currency?.name} - ${slabToEdit?.currency?.code}`,
        code: slabToEdit?.currency?.code,
        value: slabToEdit?.currency?.id,
      });
    }
  }, [slabToEdit]);

  const handleCloseModal = (event, reason) => {
    if (reason && reason === "backdropClick") return;
    onClose();
  };

  return (
    <>
      <Dialog
        open={isOpen}
        fullWidth
        maxWidth={"sm"}
        onClose={handleCloseModal}
        scroll={"body"}
        BackdropProps={{ style: { backgroundColor: "rgba(11, 5, 35, 0.8)" } }}
        PaperProps={{
          style: {
            boxShadow: "none",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontSize: "22px !important" }}>
          {isEdit ? `Edit Markup Fee` : `Add New Markup Fee`}
        </DialogTitle>
        <form onSubmit={formik.handleSubmit}>
          <DialogContent
            sx={{
              paddingTop: "20px !important",
              paddingBottom: "0 !important",
            }}
          >
            <Stack
              spacing={2}
              direction={"column"}
              alignItems={"center"}
              mb={1}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(1, 1fr)",
                  gap: 1,
                  width: "100%",
                }}
              >
                <SearchableSelectField
                  label="Currency"
                  name="currency"
                  placeholder="Type to search"
                  formik={formik}
                  // fetchOptions={fetchOptions}
                  fetchOptions={(query) =>
                    searchableSelectFetchOptions(
                      "/currency/",
                      query,
                      null,
                      (val) =>
                        val?.data?.map((item) => ({
                          label: `${item?.name} - ${item?.code}`,
                          code: item?.code,
                          value: item?.id,
                        }))
                    )
                  }
                  required
                />
                <TextFieldComponent
                  formik={formik}
                  name={"fee"}
                  type={"number"}
                  label={"Fee"}
                  inputProps={{
                    endAdornment: (
                      <InputAdornment position="end">{"%"}</InputAdornment>
                    ),
                  }}
                />
              </Box>
            </Stack>

            <DialogActions sx={{ justifyContent: "space-between" }}>
              <Button
                className="btn white-btn action-button "
                onClick={onClose}
                appearance="subtle"
              >
                Cancel
              </Button>
              <Button
                className={`btn action-button primary_color text-white`}
                appearance="primary"
                type={"submit"}
                disabled={!formik.isValid}
                loading={loading}
              >
                {isEdit ? "Update Fee" : "Add Fee"}
              </Button>
            </DialogActions>
          </DialogContent>
        </form>
      </Dialog>
    </>
  );
};

export default AddEditMarkupFeeModal;
